import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import KenColors from '../../themes/KenColors';
import { Box, Grid, useTheme } from '@material-ui/core';
import KenCard from '../../components/KenCard/index';
import Header from '../Header';
import SignIn from './signIn';
import countryCodes from '../../json/countryISDCode.json';
import { useHistory } from 'react-router-dom';
import Register from './signUp';
import Carousel from 'react-material-ui-carousel';
import configContext from '../../utils/config';

const options = countryCodes.codes;

const useStyles = makeStyles((theme) => ({
  header: {
    padding: 8,
    boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,
  },
  banner: {
    backgroundImage: `url("https://inazstgpfs3001.blob.core.windows.net/assets/snma-banner4-01.jpg")`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    alignItems: 'normal',
    position: 'relative',
  },
  bannerMultiple: {
    alignItems: 'normal',
    height: '400px',
    position: 'relative',
  },
  bannerImgMultiple: {
    width: '100%',
    height: '630px',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      paddingTop: '25px',
    },
    // cursor: "pointer",
  },
  formDetailsMultiple: {
    padding: 16,
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    [theme.breakpoints.down('sm')]: {
      position: 'initial',
      padding: 12,
    },
  },

  boxParent: {
    position: 'relative',
  },

  carouselWrapMultiple: {
    width: '100%',
  },
  right: {
    height: '100%',
    padding: '10px',
  },
}));

export default function OverlayLayout(props) {
  const [signActive, setSignActive] = useState(true);
  const [existingActive, setExistingActive] = useState(false);
  const { handleSnackbarOpen } = props;
  const { config } = React.useContext(configContext);
  const landingConfig = config;

  const [open, setOpen] = React.useState(false);

  const [user, setUser] = useState({ firstName: '', lastName: '' });
  const history = useHistory();

  const isCarousel = landingConfig?.banner?.images?.length >= 2;
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason, submitted) => {
    setOpen(false);
  };
  const classes = useStyles();
  const toggle = () => {
    setSignActive(!signActive);
    setExistingActive(!existingActive);
  };

  return (
    <React.Fragment>
      <Grid container xs={12}>
        <Grid container xs={12} className={classes.header}>
          <Header
            isLogo={false}
            instituteDetails={landingConfig.supportText}
            firstName={user.First_Name}
            lastName={user.Last_Name}
          />
        </Grid>
        <Grid
          container
          item
          direction="row"
          justify="space-between"
          alignItems="center"
          xs={12}
          className={classes.bannerMultiple}
        >
          <Carousel
            className={classes.carouselWrapMultiple}
            autoPlay={true}
            interval={4000}
            indicators={isCarousel}
            navButtonsAlwaysInvisible={!isCarousel}
          >
            {landingConfig?.banner?.images?.map((item, i) => (
              <div className={classes.imgWrap}>
                <img src={item.url} className={classes.bannerImgMultiple}></img>
              </div>
            ))}
          </Carousel>
          <Grid md={4} xs={12} className={classes.formDetailsMultiple}>
            <KenCard>
              <Box className={classes.boxParent}>
                {signActive === true && (
                  <Register
                    options={[]}
                    retrieve={true}
                    toggle={toggle}
                    notify={true}
                    handleClose={handleClose}
                    handleSnackbarOpen={handleSnackbarOpen}
                  ></Register>
                )}
                {existingActive === true && (
                  <SignIn
                    retrieve={true}
                    toggle={toggle}
                    notify={true}
                    handleClose={handleClose}
                    handleSnackbarOpen={handleSnackbarOpen}
                  />
                )}
              </Box>
            </KenCard>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
